// Utility helpers for manipulating the browser URL query string without reloading.

type UpdateRecord = Record<string, string | null | undefined>;

interface UpdateOptions {
  replace?: boolean;
  state?: Record<string, any>;
}

export function updateUrlParams(updates: UpdateRecord, options: UpdateOptions = {}) {
  if (typeof window === 'undefined') return;

  const { replace = true, state } = options;
  const url = new URL(window.location.href);
  const params = url.searchParams;

  Object.entries(updates).forEach(([key, value]) => {
    if (value === undefined) return;
    if (value === null || value === '') params.delete(key);
    else params.set(key, value);
  });

  const newSearch = params.toString();
  const newUrl = `${url.pathname}${newSearch ? `?${newSearch}` : ''}${url.hash}`;
  const nextState = { ...(window.history.state || {}), ...(state || {}) };

  if (replace) {
    window.history.replaceState(nextState, '', newUrl);
  } else {
    window.history.pushState(nextState, '', newUrl);
  }
}
